import { getCurrentUser } from './lib/supabase.js';
// v30.10: Cleaned legacy BOD imports + routes (audit cleanup)
import { checkProjectGate, clearSessionCache } from './lib/session.js';
import { renderSidebar, highlightActiveNav } from './components/sidebar.js';
import { renderLogin } from './pages/login.js';
import { renderProjectSelect } from './pages/project-select.js';
import { renderDashboard } from './pages/dashboard.js';
import { renderHopDongList, renderHopDongForm } from './pages/hop-dong.js';
import { renderHdDetail } from './pages/hd-detail.js';
import { renderChiPhiList, renderChiPhiForm } from './pages/chi-phi.js';
import { renderPycttList, renderPycttForm } from './pages/pyctt.js';
import { renderXuatKho } from './pages/xuat-kho.js';
import { renderKho } from './pages/kho.js';
import { renderVatTuForm } from './pages/vat-tu.js';
import { renderCashFlow } from './pages/cashflow.js';
import { renderEfficiency } from './pages/efficiency.js';
import { renderPrepaid } from './pages/prepaid.js';
import { renderApprovals } from './pages/approvals.js';
import { renderQuickApprove } from './pages/quick-approve.js';
import { renderIFRS } from './pages/ifrs.js';
import { renderFPA } from './pages/fpa.js';
import { renderDuAn } from './pages/du-an.js';
import { renderDoanhSo } from './pages/doanh-so.js';
import { renderNganSach } from './pages/ngan-sach.js';
import { renderPhuLuc } from './pages/phu-luc.js';
import { renderDonHang } from './pages/don-hang.js';
import { renderPLIFRS } from './pages/pl-ifrs.js';
import { renderAdmin } from './pages/admin.js';
// v29: BOD Dashboards V2 (5 trang)
import { renderBodV2Health } from './pages/bod-v2-health.js';
import { renderBodV2Pnl } from './pages/bod-v2-pnl.js';
import { renderBodV2Cash } from './pages/bod-v2-cash.js';
import { renderBodV2Crisis } from './pages/bod-v2-crisis.js';
import { renderBodV2Strategy } from './pages/bod-v2-strategy.js';

const ROUTES = [
  { pattern: /^#\/login$/,                handler: renderLogin, public: true },
  { pattern: /^#\/project-select$/,       handler: renderProjectSelect, bare: true },
  { pattern: /^#\/dashboard$/,            handler: renderDashboard },
  { pattern: /^#\/hop-dong$/,             handler: renderHopDongList },
  { pattern: /^#\/hop-dong\/new$/,        handler: () => renderHopDongForm(null) },
  { pattern: /^#\/hop-dong\/([^/]+)$/,    handler: (m) => renderHopDongForm(m[1]) },
  { pattern: /^#\/hd-detail$/,            handler: () => renderHdDetail(null) },
  { pattern: /^#\/hd-detail\/(.+)$/,      handler: (m) => renderHdDetail(decodeURIComponent(m[1])) },
  { pattern: /^#\/chi-phi$/,              handler: renderChiPhiList },
  { pattern: /^#\/chi-phi\/new$/,         handler: () => renderChiPhiForm(null) },
  { pattern: /^#\/chi-phi\/([^/]+)$/,     handler: (m) => renderChiPhiForm(m[1]) },
  { pattern: /^#\/pyctt$/,                handler: renderPycttList },
  { pattern: /^#\/pyctt\/new$/,           handler: () => renderPycttForm(null) },
  { pattern: /^#\/pyctt\/([^/]+)$/,       handler: (m) => renderPycttForm(m[1]) },
  { pattern: /^#\/phu-luc$/,              handler: renderPhuLuc, roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/don-hang$/,             handler: renderDonHang, roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/xuat-kho$/,             handler: renderXuatKho, roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/kho$/,                  handler: renderKho },
  { pattern: /^#\/cashflow$/,             handler: renderCashFlow, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/efficiency$/,           handler: renderEfficiency, roles: ['approver_l1','approver_l2','approver','admin'] },
  // v30.10: Removed 5 legacy BOD routes (bod-overview, crisis, pnl, cash, strategy)
  { pattern: /^#\/vat-tu\/new$/,          handler: () => renderVatTuForm(null), roles: ['admin'] },
  { pattern: /^#\/vat-tu\/(.+)$/,         handler: (m) => renderVatTuForm(decodeURIComponent(m[1])), roles: ['admin'] },
  { pattern: /^#\/prepaid$/,              handler: renderPrepaid, roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/approvals$/,            handler: renderApprovals, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/quick-approve$/,        handler: renderQuickApprove, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/ifrs$/,                 handler: renderIFRS, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/fpa$/,                  handler: renderFPA, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/du-an$/,                handler: renderDuAn, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/doanh-so$/,             handler: renderDoanhSo, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/ngan-sach$/,            handler: renderNganSach, roles: ['approver_l1','approver_l2','approver','admin'] },
  { pattern: /^#\/admin$/,                handler: renderAdmin, roles: ['admin'] },
  // v29: BOD Dashboards V2 (5 trang) - approver_l2/approver/admin/bod
  { pattern: /^#\/bod\/v2\/health$/,    handler: renderBodV2Health,   roles: ['approver_l2','approver','admin','bod'] },
  { pattern: /^#\/bod\/v2\/pnl$/,       handler: renderBodV2Pnl,      roles: ['approver_l2','approver','admin','bod'] },
  { pattern: /^#\/bod\/v2\/cash$/,      handler: renderBodV2Cash,     roles: ['approver_l2','approver','admin','bod'] },
  { pattern: /^#\/bod\/v2\/crisis$/,    handler: renderBodV2Crisis,   roles: ['approver_l2','approver','admin','bod'] },
  { pattern: /^#\/bod\/v2\/strategy$/,  handler: renderBodV2Strategy, roles: ['approver_l2','approver','admin','bod'] },
  { pattern: /^#\/baocao\/pl-ifrs$/,    handler: renderPLIFRS, roles: ['approver_l2','approver','admin','bod'] }
];

export async function route() {
  const hash = window.location.hash || '#/dashboard';
  const user = await getCurrentUser();
  const match = ROUTES.find(r => r.pattern.test(hash));

  if (!user) {
    clearSessionCache();
    if (!match || !match.public) { window.location.hash = '#/login'; return; }
    document.getElementById('app').innerHTML = `<div class="login-container">${await match.handler()}</div>`;
    attachPageHandlers();
    return;
  }
  if (hash === '#/login') { window.location.hash = '#/dashboard'; return; }

  // Project gate: data_entry pháº£i chá»n dá»± Ã¡n trÆ°á»›c khi vÃ o báº¥t ká»³ trang nÃ o
  if (hash !== '#/project-select') {
    try {
      const gate = await checkProjectGate(user);
      if (gate.needsPick) {
        window.location.hash = '#/project-select';
        return;
      }
      if (gate.noAccess) {
        document.getElementById('app').innerHTML = `
          <div class="login-container"><div class="login-box" style="max-width:500px">
            <h2 style="color:#991B1B">ðŸš« ChÆ°a Ä‘Æ°á»£c cáº¥p quyá»n</h2>
            <p>Báº¡n chÆ°a Ä‘Æ°á»£c cáº¥p quyá»n vÃ o báº¥t ká»³ dá»± Ã¡n nÃ o. Vui lÃ²ng liÃªn há»‡ admin.</p>
            <button class="btn btn-ghost" id="btn-logout-noaccess">ÄÄƒng xuáº¥t</button>
          </div></div>`;
        document.getElementById('btn-logout-noaccess').addEventListener('click', async () => {
          const { signOut } = await import('./lib/supabase.js');
          await signOut();
        });
        return;
      }
      user.currentProject = gate.current;
      user.myProjects = gate.projects;
    } catch (e) { console.warn('Project gate error:', e); }
  }

  if (!match) { renderLayout(user, '<div class="page"><h1>404</h1></div>'); return; }
  if (match.roles && !match.roles.includes(user.role)) {
    renderLayout(user, '<div class="page"><h1>403</h1><p>Báº¡n khÃ´ng cÃ³ quyá»n truy cáº­p trang nÃ y.</p></div>');
    return;
  }
  const m = hash.match(match.pattern);
  const content = await match.handler(m);

  // Bare mode: khÃ´ng render sidebar/layout (cho project-select)
  if (match.bare) {
    document.getElementById('app').innerHTML = content;
    attachPageHandlers();
    return;
  }
  renderLayout(user, content);
}

function renderLayout(user, content) {
  // v29.9: Sidebar toggle - responsive default
  // Desktop (>=1024px): sidebar OPEN by default (or saved state); Mobile (<1024px): CLOSED by default
  const isMobile = window.innerWidth < 1024;
  const savedDesktopState = localStorage.getItem('vnec_sidebar_open');
  const sidebarOpen = isMobile ? false : (savedDesktopState !== '0');
  const layoutClass = `layout${sidebarOpen ? ' sidebar-open' : ' sidebar-collapsed'}`;

  document.getElementById('app').innerHTML = `
    <div class="${layoutClass}" id="app-layout">
      <button class="sidebar-toggle" id="sb-toggle" aria-label="Toggle sidebar" title="áº¨n/hiá»‡n sidebar (Ctrl+B)">â˜°</button>
      <div class="sidebar-overlay" id="sb-overlay"></div>
      ${renderSidebar(user)}
      <main class="main">${content}</main>
    </div>`;
  highlightActiveNav();
  attachPageHandlers();
  wireSidebarToggle();
  const logoutBtn = document.getElementById('btn-logout');
  if (logoutBtn) logoutBtn.addEventListener('click', async () => {
    const { signOut } = await import('./lib/supabase.js');
    await signOut();
  });
}

// v29.9: Sidebar toggle wiring
function wireSidebarToggle() {
  const layout = document.getElementById('app-layout');
  const toggleBtn = document.getElementById('sb-toggle');
  const overlay = document.getElementById('sb-overlay');
  if (!layout || !toggleBtn) return;

  function setSidebar(open) {
    layout.classList.toggle('sidebar-open', open);
    layout.classList.toggle('sidebar-collapsed', !open);
    if (window.innerWidth >= 1024) {
      localStorage.setItem('vnec_sidebar_open', open ? '1' : '0');
    }
  }

  toggleBtn.addEventListener('click', () => {
    setSidebar(!layout.classList.contains('sidebar-open'));
  });

  if (overlay) overlay.addEventListener('click', () => setSidebar(false));

  // Mobile: tap nav-item auto-close
  layout.querySelectorAll('.sidebar .nav-item').forEach(navEl => {
    navEl.addEventListener('click', () => {
      if (window.innerWidth < 1024) setTimeout(() => setSidebar(false), 100);
    });
  });

  // Ctrl+B keyboard shortcut (skip when typing in input/textarea/select)
  document.addEventListener('keydown', function(e) {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'b' && !e.shiftKey && !e.altKey) {
      if (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return;
      e.preventDefault();
      setSidebar(!layout.classList.contains('sidebar-open'));
    }
  });
}

function attachPageHandlers() {
  if (window.__pageInit) {
    try { window.__pageInit(); } catch(e) { console.error('pageInit error:', e); }
    window.__pageInit = null;
  }
}
